const input = () => {

    const parent        = '.js-input';
    const input         = $('.js-default-input');
    const clear         = $('.js-input-clear');
    const confirmation  = '.js-code-confirmation';
    const emptyClass    = 'input--not-empty';
    const errorClass    = 'input--error';
    const successClass  = 'input--success';
    let buttonDisabled  = true;

    input.on('keyup keydown', function(){
        const thisParent = $(this).parents(parent);

        if ( $(this).val() != '' ) {
            thisParent.addClass(emptyClass);
            buttonDisabled = false;

        } else {
            thisParent.removeClass(emptyClass);
            buttonDisabled = true;
        }

        if (typeof $(this).attr('data-button-confirm') !== 'undefined') {
            const id      = $(this).attr('data-button-confirm');
            const confirm = $(this).parents(confirmation);

            if (!buttonDisabled) {
                confirm.find(id).attr('disabled', false);

            } else {
                confirm.find(id).attr('disabled', true);
            }
        }
    });
    clear.on('click', function(){
        const thisParent = $(this).parents(parent);
        const thisInput  = thisParent.find('.js-default-input');

        if ( thisInput.val() != '' ) {
            thisInput.val('').trigger('keydown');
            thisParent.removeClass(emptyClass + " " + errorClass + " " + successClass);
        }
    });

}